import { defineMessages } from 'react-intl';

const messages = {
  deepintegration:
    defineMessages({
      headerDefaultReview: {
        id: '',
        description: 'Dropbox header for Review',
        defaultMessage: 'Does everything look right?',
      },
    }),
  sharepoint:
    defineMessages({
      headerMeOnlyFlowReview: {
        id: '',
        description: 'Header for Just me flow Review',
        defaultMessage: 'Send your completed document',
      },
    }),
};

export default messages;
